module.exports = __webpack_public_path__ + "media/application/assets/images/spot2-fbd06db20b65058a03ac916a572c913c.jpg";